import { useState } from 'react';
import { useSpring, animated } from '@react-spring/web';
import { 
    LOCATION_LIST, 
    LOCATION_CONFIG, 
    SEASON, 
    TIME_OF_DAY, 
    MAP_IMAGE_SRC, 
    DEFAULT_SCENE_MEDIA
} from '../SceneComponents/VideoConfig.jsx';
import { playClickSound } from './SoundEffect'; 
import { InfoPopup } from './InfoPopup.jsx'; 

export default function DialogBox({
    title = "Die neue Tribschenstrasse\n– ein lebenswerter Strassenraum!",
    text = (
    <>
        Klicke auf die Punkte entlang der Strasse 
        <br />
        und erlebe die neuen Qualitäten dieses urbanen Grünraumes.
         <br />
         <br />
        5G<sup><img src="/images/ui/T_UI_5G.png" alt="5G" className="inline-icon" /></sup> empfohlen.
    </>
    ),    onHotspotClick
}) {
    const [isInfoOpen, setIsInfoOpen] = useState(false);
    const [isInfoHovered, setIsInfoHovered] = useState(false);

    const [springs, api] = useSpring(() => ({
        transform: 'translateY(0%)',
        opacity: 1,
    }));

    const handlePointSelect = (sceneMedia) => { 
        playClickSound(); 
        api.start({
            to: { transform: 'translateY(-200%)', opacity: 0 },
            onResolve: async () => {
                if (onHotspotClick) {
                    await onHotspotClick(sceneMedia);
                }
            }
        });
    };

    const handleBackgroundClick = () => {
        if (isInfoOpen) return;
        const defaultMedia = DEFAULT_SCENE_MEDIA;
        handlePointSelect(defaultMedia);
    };

    return (
        <>
            {/* 1. BACKDROP OVERLAY */}
            <div 
                className={`info-backdrop-overlay ${isInfoOpen ? 'open' : ''}`}
                onClick={() => setIsInfoOpen(false)} 
            />

            {/* 2. INFO POPUP CONTAINER */}
            <div className={`info-popup-wrapper ${isInfoOpen ? 'open' : ''}`}>
                <div style={{ pointerEvents: isInfoOpen ? 'auto' : 'none', width: '100%', height: '100%' }}>
                    <InfoPopup isOpen={isInfoOpen} onClose={() => setIsInfoOpen(false)} />
                </div>
            </div>

            <div className="overlay overlay-center" onClick={handleBackgroundClick}>
                <animated.div 
                    className="dialog-box" 
                    style={springs}
                >
                    <h2 className="dialog-box-title">{title}</h2>
                    
                    <div className="map-interaction-container">
                        <img src={MAP_IMAGE_SRC} alt="Tribschenstrasse Map" className="map-base-graphic" />
                        
                        {LOCATION_LIST.map((loc) => (
                            <button
                                key={loc.id}
                                className="ui-map-hotspot" 
                                style={{ 
                                    position: 'absolute', 
                                    top: loc.top, 
                                    left: loc.left 
                                }}
                                onClick={(e) => {
                                    e.stopPropagation(); 
                                    const targetMedia = LOCATION_CONFIG[loc.id].media[SEASON.SPRING][TIME_OF_DAY.MORNING];
                                    handlePointSelect(targetMedia);
                                }}
                            />
                        ))}
                    </div>

                    <p className="dialog-box-text">{text}</p>

                    {/* Info Button */}
                    <div className="dialog-info-button-container" style={{ display: 'flex', justifyContent: 'center', marginTop: '15px' }}>
                        <button 
                            type="button" 
                            className="pill-icon-button" 
                            style={{ transform: 'scale(0.75)' }} 
                            onClick={(e) => { 
                                e.stopPropagation(); 
                                setIsInfoOpen(true); 
                                playClickSound(); 
                            }} 
                            onMouseEnter={() => setIsInfoHovered(true)} 
                            onMouseLeave={() => setIsInfoHovered(false)}
                        >
                            <img src={isInfoHovered ? "/images/ui/T_Icons/T_Icon_Info_Glow.png" : "/images/ui/T_Icons/T_Icon_Info.png"} alt="Info" />
                        </button>
                    </div>
                </animated.div>
            </div>
        </>
    );
}